<app-modal #editForm [size]="'large'" [scrollable]="true">
  @if (model?.id) {
    <app-modal-header>{{ 'COMPANY.UPDATE_TITLE' | translate }} #{{ model.id }}</app-modal-header>
  }
  @if (!model?.id) {
    <app-modal-header>{{ 'COMPANY.ADD_TITLE' | translate }}</app-modal-header>
  }

  <app-modal-body>
    @if (model) {
      <div class="container-fluid company-form">
        <fieldset class="mb-4">
          <legend class="h6 text-uppercase text-muted border-bottom pb-2 mb-3">
            {{ 'COMPANY.SECTION_IDENTITY' | translate }}
          </legend>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label" for="taxId">
                {{ 'COMPANY.TAXID' | translate }} <span class="text-danger">*</span>
              </label>
              <input id="taxId" type="text" class="form-control"
                [(ngModel)]="model.tax_id" #taxId="ngModel"
                [ngModelOptions]="{ standalone: true }" required
                [class.is-invalid]="taxId.invalid && taxId.touched">
              <div class="invalid-feedback">{{ 'COMPANY.FIELD_REQUIRED' | translate }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="companyName">
                {{ 'COMPANY.NAME' | translate }} <span class="text-danger">*</span>
              </label>
              <input id="companyName" type="text" class="form-control"
                [(ngModel)]="model.company_name" #companyName="ngModel"
                [ngModelOptions]="{ standalone: true }" required
                [class.is-invalid]="companyName.invalid && companyName.touched">
              <div class="invalid-feedback">{{ 'COMPANY.FIELD_REQUIRED' | translate }}</div>
            </div>
            <div class="col-md-6">
              <label class="form-label" for="firstName">{{ 'COMPANY.FIRSTNAME' | translate }}</label>
              <input id="firstName" type="text" class="form-control"
                [(ngModel)]="model.first_name" [ngModelOptions]="{ standalone: true }">
            </div>
            <div class="col-md-6">
              <label class="form-label" for="lastName">{{ 'COMPANY.LASTNAME' | translate }}</label>
              <input id="lastName" type="text" class="form-control"
                [(ngModel)]="model.last_name" [ngModelOptions]="{ standalone: true }">
            </div>
          </div>
        </fieldset>
        @if (model.properties) {
          <fieldset>
            <legend class="h6 text-uppercase text-muted border-bottom pb-2 mb-3">
              {{ 'COMPANY.SECTION_FISCAL' | translate }}
            </legend>
            <div class="row g-3">
              @for (prop of propertyFields; track prop) {
                <div class="col-md-6">
                  <label class="form-label" [attr.for]="prop">{{ prop }}</label>
                  <input [id]="prop" type="text" class="form-control"
                    [(ngModel)]="model.properties[prop]" [ngModelOptions]="{ standalone: true }">
                </div>
              }
            </div>
          </fieldset>
        }
      </div>
    }
  </app-modal-body>

  <app-modal-footer>
    <div class="d-flex justify-content-end gap-2 modal-footer-width">
      <div class="btn-group-sm" role="group" aria-label="Basic example">
        <button type="button" class="btn btn-outline-secondary" style="min-width: 120px;" (click)="cancel()">
          {{ 'COMPANY.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary" style="min-width: 120px;" [disabled]="!isValid" (click)="upsert()">
          {{ 'COMPANY.SAVE' | translate }}
        </button>
      </div>
    </div>
  </app-modal-footer>
</app-modal>
